import React from 'react';
import { Helmet } from 'react-helmet-async';
import MainLayout from '../layouts/MainLayout';
import { GiftOutlined, PercentageOutlined, TagOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const Campaigns = () => {
    const campaigns = [
        {
            id: 1,
            title: 'Kış Lastiği Kampanyası',
            description: '4 adet kış lastiği alımlarında montaj ve balans ücretsiz! Güvenli kış sürüşü için şimdi fırsatı kaçırmayın.',
            discount: '%20 İndirim',
            validUntil: '31 Aralık 2025',
            icon: <GiftOutlined className="text-5xl text-orange-600" />,
            image: '/images/araba-lastik-bg.webp',
            badge: 'Popüler'
        },
        {
            id: 2,
            title: 'Yaz Lastiği Erken Rezervasyon',
            description: 'Yaz lastiklerinizi şimdiden sipariş edin, sezon başında %15 indirimli alın. Erken rezervasyon avantajı!',
            discount: '%15 İndirim',
            validUntil: '15 Mart 2026',
            icon: <PercentageOutlined className="text-5xl text-orange-600" />,
            image: '/images/araba-lastik-bg.webp',
            badge: 'Yeni'
        },
        {
            id: 3,
            title: 'Michelin Lastik Özel Kampanyası',
            description: 'Tüm Michelin lastiklerinde geçerli! 4 adet alımlarda ekstra indirim ve 2 yıl garanti.',
            discount: '%10 İndirim',
            validUntil: '30 Kasım 2025',
            icon: <TagOutlined className="text-5xl text-orange-600" />,
            image: '/images/araba-lastik-bg.webp',
            badge: 'Sınırlı'
        },
        {
            id: 4,
            title: 'Ticari Araç Fırsatları',
            description: 'Kamyon ve kamyonet lastiklerinde toplu alımlarda %25\'e varan indirimler! Filo müşterilerine özel.',
            discount: '%25\'e Varan',
            validUntil: 'Stoklar Tükenene Kadar',
            icon: <ClockCircleOutlined className="text-5xl text-orange-600" />,
            image: '/images/araba-lastik-bg.webp',
            badge: 'Filo'
        }
    ];

    const seasonalOffers = [
        {
            title: 'Ücretsiz Lastik Bakımı',
            description: 'Bizden aldığınız lastiklere 1 yıl boyunca ücretsiz hava basıncı kontrolü ve lastik bakımı'
        },
        {
            title: 'Kredi Kartına Taksit',
            description: 'Tüm kredi kartlarına 6 aya varan taksit imkanı. Peşin fiyatına 6 taksit!'
        },
        {
            title: 'Eski Lastik Değişim',
            description: 'Eski lastiklerinizi getirin, yenilerinde indirim kazanın. Çevre dostu geri dönüşüm'
        }
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Kampanyalar - Sakarya Lastik | Özel İndirimler ve Fırsatlar</title>
                <meta name="description" content="Sakarya Lastik kampanyaları ve özel fırsatları. Kış lastiği, yaz lastiği ve tüm markalarda indirimli fiyatlar. Ücretsiz montaj fırsatları!" />
                <meta name="keywords" content="lastik kampanyası, lastik indirimi, kış lastiği kampanya, yaz lastiği fırsat, sakarya lastik indirim" />
            </Helmet>

            {/* Hero Section */}
            <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white py-16 mb-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Kampanyalar ve Fırsatlar</h1>
                    <p className="text-xl text-orange-100 max-w-2xl">
                        Kaliteli lastikleri en uygun fiyatlarla almak için özel kampanyalarımızı kaçırmayın!
                    </p>
                </div>
            </div>

            {/* Main Campaigns */}
            <div className="container mx-auto px-4 py-12">
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    {campaigns.map((campaign) => (
                        <div key={campaign.id} className="bg-white rounded-lg shadow-xl overflow-hidden hover:shadow-2xl transition-shadow relative">
                            {campaign.badge && (
                                <div className="absolute top-4 right-4 z-10">
                                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                                        {campaign.badge}
                                    </span>
                                </div>
                            )}
                            <div className="relative h-48 bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                                {campaign.icon}
                            </div>
                            <div className="p-6">
                                <div className="flex items-center justify-between mb-3">
                                    <h3 className="text-2xl font-bold text-gray-800">
                                        {campaign.title}
                                    </h3>
                                    <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-bold">
                                        {campaign.discount}
                                    </span>
                                </div>
                                <p className="text-gray-600 mb-4 leading-relaxed">
                                    {campaign.description}
                                </p>
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-gray-500 flex items-center">
                                        <ClockCircleOutlined className="mr-2" />
                                        {campaign.validUntil}
                                    </span>
                                    <Button type="primary" className="bg-orange-600 hover:bg-orange-700">
                                        Detaylı Bilgi
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Seasonal Offers */}
                <div className="bg-orange-50 rounded-lg p-8 mb-12">
                    <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                        Sürekli Avantajlar
                    </h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        {seasonalOffers.map((offer, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                                <h3 className="text-xl font-bold text-orange-600 mb-3">
                                    {offer.title}
                                </h3>
                                <p className="text-gray-600">
                                    {offer.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA Section */}
                <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg p-12 text-center">
                    <h2 className="text-3xl font-bold mb-4">Kampanyalardan Yararlanmak İçin</h2>
                    <p className="text-xl text-gray-300 mb-6 max-w-2xl mx-auto">
                        Hemen bizi arayın veya mağazamızı ziyaret edin. Uzman ekibimiz size en uygun kampanyayı önerecektir.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Button
                            size="large"
                            className="bg-orange-600 hover:bg-orange-700 text-white border-none h-12 px-8"
                        >
                            <a href="tel:+905441205454" className="flex items-center">
                                📞 Hemen Ara
                            </a>
                        </Button>
                        <Button
                            size="large"
                            className="bg-white text-gray-800 hover:bg-gray-100 h-12 px-8"
                        >
                            <a href="/iletisim">
                                📍 Mağazayı Ziyaret Et
                            </a>
                        </Button>
                    </div>
                </div>

                {/* Terms */}
                <div className="mt-12 text-center text-sm text-gray-500">
                    <p>* Kampanyalar stokla sınırlıdır. Kampanya şartları için mağazamızı arayabilirsiniz.</p>
                    <p>* Kampanyalar aynı anda kullanılamaz. En avantajlı kampanya uygulanır.</p>
                </div>
            </div>
        </MainLayout>
    );
};

export default Campaigns;
